module.exports = __webpack_public_path__ + "img/nibss-logo.6c5a9410.png";